import { ScribeTranscriptLine } from "./types";

/**
 * Folds consecutive lines from the same speaker into one turn, so a pause
 * mid-sentence continues the current bubble instead of opening a new one.
 */
export const groupTranscriptTurns = (
  lines: ScribeTranscriptLine[]
): ScribeTranscriptLine[] =>
  lines.reduce<ScribeTranscriptLine[]>((turns, line) => {
    const previous = turns[turns.length - 1];
    const isSameSpeaker =
      !!previous &&
      previous.role === line.role &&
      previous.speaker === line.speaker;

    if (!isSameSpeaker) return [...turns, line];

    return [
      ...turns.slice(0, -1),
      { ...previous, text: `${previous.text} ${line.text}` },
    ];
  }, []);

/** One `[timestamp] Speaker: text` line per turn, in conversation order. */
export const formatTranscriptForCopy = (
  lines: ScribeTranscriptLine[]
): string =>
  groupTranscriptTurns(lines)
    .map((turn) => `[${turn.timestamp}] ${turn.speaker}: ${turn.text}`)
    .join("\n");
